<template>
  <div>
    <h1 class="page-header">
      Setup Location
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-lg-6 col-md-6">
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"> Location Name KH</label>
              <div class="col-md-7">
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('location_name_kh') }"
                  v-model="model.location_name_kh"
                  placeholder="Location name Kh"
                />
                <div class="invalid-feedback" v-if="errors.has('location_name_kh')">
                  {{ errors.first('location_name_kh') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Location Name EN <span class="text-danger">*</span></label
              >
              <div class="col-md-7">
                <input
                  v-model="model.location_name_en"
                  type="text"
                  class="form-control kh-font"
                  :class="{ 'is-invalid': errors.has('location_name_en') }"
                  placeholder="Location name En"
                />
                <div class="invalid-feedback" v-if="errors.has('location_name_en')">
                  {{ errors.first('location_name_en') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label">
                Description
              </label>
              <div class="col-md-7">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model="model.description"
                  placeholder="Leave your description here..."
                >
                </textarea>
                <div class="invalid-feedback" v-if="errors.has('description')">
                  {{ errors.first('description') }}
                </div>
              </div>
            </div>
            <div class="form-group row m-b-t-15">
              <label class="col-md-5 form-col-label control-label"></label>
              <div class="col-sm-7">
                <div class="checkbox checkbox-css">
                  <input type="checkbox" id="cssCheckbox1" v-model="model.is_main_warehouse" />
                  <label for="cssCheckbox1"> Main Warehouse</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row  text-right">
          <div class="col-lg-12">
            <ts-button color="primary" :waiting="saving" @click="update">
              Update
            </ts-button>

            <ts-button class="ml-2" @click="$router.push({ name: 'location' })">
              Cancel
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import apiLocation from '@/api/administration/location'

export default {
  name: 'location-edit',
  beforeRouteEnter: async (to, from, next) => {
    let response = await apiLocation.find(to.params.id)
    to.params.editData = response.data
    next(vm => vm.setEditData())
  },
  props: ['editData'],
  data() {
    return {
      model: {
        location_id: 0,
        location_name_kh: '',
        location_name_en: '',
        description: '',
        is_main_warehouse: false
      },
      errors: new Errors(),
      saving: false,
      save_add_new: false
    }
  },
  methods: {
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('administration/location/update', Object.assign({}, this.model))
        .then(response => {
          this.saving = false
          this.$router.push({ name: 'location' })
          console.log(response)
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.saving = false
        })
    },

    setEditData() {
      this.model.location_id = this.editData.location_id
      this.model.location_name_kh = this.editData.location_name_kh
      this.model.location_name_en = this.editData.location_name_en
      this.model.description = this.editData.description
      this.model.is_main_warehouse = this.editData.is_main_warehouse
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('administration/location/RESET_STATE')
    }
    next()
  }
}
</script>
